/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch, useSelector } from 'react-redux';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { store } from '../../core/store';
import {
    platformGroupsReducers,
    platformUserDefinedRolesToGroupsConstants,
    platformUserDefinedRolesToGroupsReducers,
    rolesCredentialConstants,
    rolesCredentialReducers,
    rolesCredentialType,
} from '../../modules/platformGroups/reducers';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { UserPermissionGroupSubElements } from './UserPermissionGroupSubElements';
import { Auth } from '../../modules/auth/Auth';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';

store.injectReducer('platformGroupsReducers', platformGroupsReducers);
store.injectReducer('platformUserDefinedRolesToGroupsReducers', platformUserDefinedRolesToGroupsReducers);
store.injectReducer('rolesCredentialReducers', rolesCredentialReducers);

const _ = require('underscore');

export const UserPermissionGroupAssignment = (props: {
    checkedElements: any;
    setCheckedElements: React.Dispatch<any>;
    id?: number | null;
}): React.ReactElement => {
    const dispatch = useDispatch();
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();

    const [menu, setMenu] = useState<any>(null);

    const ROLES_CREDENTIALS = '/roles_credentials';
    const MENU_PLATFORM_URI = '/menu_platforms';
    const [isRootLogged, setIsRootLogged] = useState<boolean>(false);

    const { collections } = useSelector((state: { rolesCredentialReducers: rolesCredentialType }) => {
        return state.rolesCredentialReducers;
    });

    const loadMenu = useCallback(
        (uri?: string) => {
            if (!uri) {
                uri = FormGeneralHelper.getPath(MENU_PLATFORM_URI);
            }
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(uri),
                platformUserDefinedRolesToGroupsConstants.LIST,
                [
                    { name: 'parent', value: 0 },
                    { name: 'platformType', value: Auth.getPlatformType() },
                    { name: 'loadAll', value: true },
                ],
                [{ name: 'menuOrder', value: 'asc' }],
                (data: any) => {
                    setMenu(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        },
        [dispatch]
    );

    const loadCustomRoles = useCallback(
        (elements: any = null, uri?: string) => {
            if (!uri) {
                uri = FormGeneralHelper.getPath(ROLES_CREDENTIALS);
            }
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(FormGeneralHelper.getByUri(uri), rolesCredentialConstants.LIST, [], [], (data: any) => {}, {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            });
        },
        [dispatch]
    );

    const loadPlatformReseller = useCallback((): void => {
        const itemLoader = new ItemLoaders(dispatch);
        const platformResellerLoader = new PlatformResellerLoader(itemLoader);
        platformResellerLoader.loadPlatformResellerById(
            Auth.getUserPlatformResellerId(),
            (data: any) => {
                if (data && data.parentResellerId) {
                    setIsRootLogged(false);
                } else {
                    setIsRootLogged(true);
                }
            },
            { dispatchAfterCallback: true, propagateDataToCallback: true }
        );
    }, [dispatch]);

    useEffect(() => {
        loadCustomRoles();
        loadMenu();
        loadPlatformReseller();
    }, [loadCustomRoles, loadMenu, loadPlatformReseller]);

    return (
        <div>
            {menu &&
                menu['hydra:member'].map((el: any) => {
                    let visibleForNotRoot = false;
                    if (isRootLogged) {
                        visibleForNotRoot = true;
                    } else {
                        if (el.subMenus.length === 0) {
                            collections &&
                                collections['hydra:member'].map((rolesCredential: any) => {
                                    if (el.menuName === rolesCredential.permissionRoleName && !rolesCredential.rootOnly) {
                                        visibleForNotRoot = true;
                                    }
                                });
                        } else {
                            visibleForNotRoot = true;
                        }
                    }

                    if (el.visible && visibleForNotRoot) {
                        return (
                            <Accordion key={el.id}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography className={classes.heading}>
                                        <I18n trans={`general:menu.${el.menuName}`} />
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <UserPermissionGroupSubElements
                                        elements={el.subMenus.length > 0 ? el.subMenus : [el]}
                                        checkedElements={props.checkedElements}
                                        setCheckedElements={props.setCheckedElements}
                                        isRootLogged={isRootLogged}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        );
                    }
                })}
        </div>
    );
};
